import { useContext, useState } from 'react';
import { useFormik } from 'formik';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, MenuItem, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import axios from 'axios';
import { API_URL, FILE_UPLOAD_TYPE } from '../constant';
import { useSnackbar } from 'notistack';
import * as yup from 'yup';
import { LoginContext } from '../context/logincontext';
import moment from 'moment';

const validationSchema = yup.object({
  type: yup.string().required('FI Type is required'),
  monthly_income: yup.string().required('Monthly Income is required'),
  address_matched: yup.string().required('Address Matched is required'),
  fi_feedback: yup.string().required('FI Feedback is required'),
  remarks: yup.string().required('Remarks are required'),
});

export default function FiForm({ open, onClose, data }) {
  const { enqueueSnackbar } = useSnackbar();
  const [files, setFiles] = useState([]);
  const [disable, setDisable] = useState(false);
  const context = useContext(LoginContext)
  const [userData,setUserData]=useState(context.user);
        
  const initialValues = {
    type: '',
    staff_id: userData?.los_staff_id,
    monthly_income: '',
    address_matched: '',
    fi_feedback: '',
    remarks: '',
    latitude: '',
    longitude: '',
    fi_photos: null,
    capture_time: moment().format('YYYY-MM-DD HH:mm:ss'),
    offlineSave: true,
    fi_type:'fi',
    source:'partners_web',
    purpose: 'fi',
    relation_id: 0,
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      handleConfirm(values)
    }
  });

  async function handleConfirm(values) {
    setDisable(true);
    const formData = new FormData();
    if (files.length) {
      formData.append(FILE_UPLOAD_TYPE.FI_PHOTOS, ...files);
    }
    const requestData = { ...values, loan_id: data?.loan_id };
    formData.append('data', JSON.stringify(requestData));

    try {
      const response = await axios.post(`${API_URL}/fi_form`, formData);
      if (response?.data?.status === 'success') {
        enqueueSnackbar('FI Form successfully submitted', { variant: 'success' });
        onClose();
      } else {
        enqueueSnackbar(response?.data?.message || 'Submission failed', { variant: 'warning' });
      }
    } catch (err) {
      enqueueSnackbar(err?.message, { variant: 'error' });
    } finally {
      formik.resetForm();
      setDisable(false);
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <h3 style={{ fontWeight: 'bold', }}>Fi Form</h3>
        <Button onClick={onClose} color="error" variant="outlined">X</Button>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Box sx={{ p: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth select label="FI Type" name="type" value={formik.values.type} onChange={formik.handleChange} error={formik.touched.type && Boolean(formik.errors.type)} helperText={formik.touched.type && formik.errors.type}>
                  <MenuItem value={'home'}>Home</MenuItem>
                  <MenuItem value={'work'}>Work</MenuItem>
                  <MenuItem value={'patta_verification'}>Patta Verification</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth select label="Address Matched" name="address_matched" value={formik.values.address_matched} onChange={formik.handleChange} error={formik.touched.address_matched && Boolean(formik.errors.address_matched)} helperText={formik.touched.address_matched && formik.errors.address_matched}>
                  <MenuItem value={'true'}>Yes</MenuItem>
                  <MenuItem value={'false'}>No</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth select label="FI Feedback" name="fi_feedback" value={formik.values.fi_feedback} onChange={formik.handleChange} error={formik.touched.fi_feedback && Boolean(formik.errors.fi_feedback)} helperText={formik.touched.fi_feedback && formik.errors.fi_feedback}>
                  <MenuItem value={'positive'}>Positive</MenuItem>
                  <MenuItem value={'negative'}>Negative</MenuItem>
                  <MenuItem value={'need_discussion'}>Need Discussion</MenuItem>
                  <MenuItem value={'not_applicable'}>Not Applicable</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Monthly Income" name="monthly_income" value={formik.values.monthly_income} onChange={formik.handleChange} error={formik.touched.monthly_income && Boolean(formik.errors.monthly_income)} helperText={formik.touched.monthly_income && formik.errors.monthly_income} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Latitude" name="latitude" value={formik.values.latitude} onChange={formik.handleChange} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Longitude" name="longitude" value={formik.values.longitude} onChange={formik.handleChange} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Remarks" name="remarks" value={formik.values.remarks} onChange={formik.handleChange} error={formik.touched.remarks && Boolean(formik.errors.remarks)} helperText={formik.touched.remarks && formik.errors.remarks} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth type="file" onChange={(e) => setFiles(Object.values(e.target.files))} />
              </Grid>
            </Grid>
          </Box>
        </form>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
        <LoadingButton loading={disable} onClick={formik.handleSubmit} variant="contained" color="primary" sx={{ width: "30%" }}>Submit</LoadingButton>
      </DialogActions>
    </Dialog>
  );
}